/**
 * Normalizes a portal domain URL by ensuring it has https:// protocol
 * and no trailing slashes. Returns a default Bynder URL if none provided.
 */
export function parseUrl(url?: string) {
    if (!url || url.includes('localhost')) {
        return `https://dam.bynder.com`;
    }

    const withoutProtocol = url.replace(/^https?:\/\//i, '');
    const withoutTrailingSlashes = withoutProtocol.replace(/\/+$/i, '');

    return `https://${withoutTrailingSlashes}`;
}

/**
 * Same normalization as `parseUrl` (trailing slashes stripped, default Bynder
 * domain fallback), but always returns the host without the protocol.
 */
export function parseUrlWithoutProtocol(url?: string) {
    return parseUrl(url).replace(/^https?:\/\//i, '');
}
